import "./scss/main.scss";
import { RouterProvider } from "react-router";
import router from "./routes";
import { useAppDispatch } from "./hooks/app";
import { setTheme } from "./redux/slices/session-slice";
import { appStorage } from "./commons";
import { useEffect } from "react";
import { setMobileView, setSmallImageCropper, setStepperFormModalSize } from "./redux/slices/screen-resize-slice";

function App() {
  const dispatch = useAppDispatch();
  const themeType = appStorage.getItem("appTheme");
  if (themeType) {
    document.documentElement.setAttribute("data-theme", themeType);
  } else {
    dispatch(setTheme("light"));
    document.documentElement.setAttribute("data-theme", "light");
  }

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 512) {
        dispatch(setMobileView(true));
        dispatch(setStepperFormModalSize("xs"));
        dispatch(setSmallImageCropper(true));
      } else if (width >= 512 && width < 768) {
        dispatch(setMobileView(true));
        dispatch(setStepperFormModalSize("sm"));
        dispatch(setSmallImageCropper(false));
      } else if (width >= 768 && width < 1024) {
        dispatch(setMobileView(false));
        dispatch(setSmallImageCropper(false));
        dispatch(setStepperFormModalSize("mdl"));
      } else {
        dispatch(setMobileView(false));
        dispatch(setSmallImageCropper(false));
        dispatch(setStepperFormModalSize("lg"));
      }
    };
    setTimeout(handleResize, 0);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <RouterProvider router={router} />
    </>
  );
}

export default App;
